import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#282f4c',// blue
            primary2: '#3441b1',// blue
            primary3: '#E84575',//pink3
            secondary: '#424242',//balck
            accent: '#82B1FF',//blue
            error: '#FF5252',//red
            info: '#2196F3',//blue
            success: '#4CAF50',//green
            warning: '#FFC107',//yellow
            text_card: '#8a8a8a'//text_card
          },
        },
      },
});
